import React from "react";

import {
  StyledModal,
  ProgressContainer,
  StyledProgress,
  LogsContainer,
  LogMessage,
  EmptyLogs,
  Button,
  FooterContainer,
} from "./styles";

interface TwygoLogsModalProps {
  isVisible: boolean;
  onClose: () => void;
  loadingBulkCourses: boolean;
  progressPercent: number;
  logs: Array<{ message: string; type: "success" | "error" | "info" }>;
  title?: string;
}

const TwygoLogsModal: React.FC<TwygoLogsModalProps> = ({
  isVisible,
  onClose,
  loadingBulkCourses,
  progressPercent,
  logs,
  title = "Logs de Vinculação",
}) => {
  const handleClose = () => {
    if (!loadingBulkCourses) {
      onClose();
    }
  };

  return (
    <StyledModal
      title={title}
      visible={isVisible}
      onCancel={handleClose}
      footer={
        <FooterContainer>
          <Button
            type="default"
            onClick={handleClose}
            disabled={loadingBulkCourses}
          >
            Fechar
          </Button>
        </FooterContainer>
      }
      width={800}
      maskClosable={!loadingBulkCourses}
      closable={!loadingBulkCourses}
      zIndex={1050}
    >
      <ProgressContainer>
        <StyledProgress
          percent={progressPercent}
          status={loadingBulkCourses ? "active" : "normal"}
        />
      </ProgressContainer>

      <LogsContainer>
        {logs.length === 0 ? (
          <EmptyLogs>Aguardando início do processo...</EmptyLogs>
        ) : (
          logs.map((log, index) => (
            <LogMessage key={index} type={log.type}>
              {log.message}
            </LogMessage>
          ))
        )}
      </LogsContainer>
    </StyledModal>
  );
};

export default TwygoLogsModal;
